import './role-details-popup-header.scss';

import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Close } from '@mui/icons-material';
import CheckRounded from '@mui/icons-material/CheckRounded';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import { Button, IconButton } from '@mui/material';
import ViewingMode from 'shared/components/viewing-mode-controller/types/viewing-mode';
import Permission from 'shared/features/auth/authorization/enums/permission';
import usePermissionAuthorization from 'shared/features/auth/authorization/hooks/permission-authorization';

interface IProps {
  onClose: () => void;
  onCancel: () => void;
  onEdit: () => void;
  onDelete: () => void;
  viewingMode: ViewingMode;
  isLoading: boolean;
}

const RoleDetailsPopupHeader = (props: Readonly<IProps>): ReactElement => {
  const { t } = useTranslation('role');
  const { hasPermission } = usePermissionAuthorization();

  return (
    <div className="role-details-header">
      {(props.viewingMode === 'creation' || props.viewingMode === 'editing') && (
        <>
          <Button data-testid="roleDetailCancelButton" variant="text" onClick={props.onCancel} disabled={props.isLoading}>
            {t('details.cancelFormButton')}
          </Button>
          <Button
            data-testid="roleDetailSubmitButton"
            startIcon={<CheckRounded />}
            variant="contained"
            type="submit"
            loading={props.isLoading}
            loadingPosition="start"
          >
            {t('details.saveFormButton')}
          </Button>
        </>
      )}
      {props.viewingMode === 'viewing' && (
        <>
          {hasPermission(Permission.DeleteRole) && (
            <Button
              data-testid="roleDetailRemoveButton"
              startIcon={<DeleteForeverOutlinedIcon className="icon-on-text" />}
              variant="text"
              onClick={props.onDelete}
              disabled={props.isLoading}
            >
              {t('details.removeFormButton')}
            </Button>
          )}
          {hasPermission(Permission.UpdateRole) && (
            <Button
              data-testid="roleDetailEditButton"
              startIcon={<ModeEditOutlineOutlinedIcon className="icon-on-text" />}
              variant="text"
              onClick={props.onEdit}
              disabled={props.isLoading}
            >
              {t('details.editFormButton')}
            </Button>
          )}
        </>
      )}

      <IconButton aria-label="close" className="close-button" onClick={props.onClose} data-testid="roleDetailsPopupCloseButton">
        <Close />
      </IconButton>
    </div>
  );
};

export default RoleDetailsPopupHeader;
